<template>
	<div>
		<common-header navbar-index=2></common-header>
		<robot-banner></robot-banner>
		<div class="container" id="link1">
			<div class="tips mt-5 pt-4 pb-4">
				<a href="javascript:void(0)" @click="toback">行业新闻</a><span class="s1">|</span><span class="s2">全国青少年机器人技术等级考试实操答题纸——参考模板</span>
			</div>
			<div class="content_item pt-4 pb-5">
				<div class="pl25 pr25">
					<div class="title mb-4">全国青少年机器人技术等级考试实操答题纸——参考模板</div>
					<p class="text" style="text-align: center;">具体以实际考试发放内容为准，以下仅供参考！</p>
					<p class="text" style="text-align:center"><img alt="" src="../../../assets/img/robot/article/7_1.png"></p>
					<p class="text" style="text-align:center"><img alt="" src="../../../assets/img/robot/article/7_2.png"></p>
					<p class="text" style="text-align:center"><img alt="" src="../../../assets/img/robot/article/7_3.png"></p>
					<p class="text" style="text-align:center"><img alt="" src="../../../assets/img/robot/article/7_4.png"></p>

					<p class="text">&nbsp;</p>
					<p style="text-align:left">原文链接：
						<a target="_blank" href="http://www.robotest.cn/article/item-319.html">http://www.robotest.cn/article/item-319.html</a>
					</p>
					<div class="clear"></div>
				</div>
			</div>
		</div>
		<common-footer></common-footer>
	</div>
</template>

<script>
	import CommonHeader from '@/pages/common/Header'
	import RobotBanner from '@/pages/robot/components/RobotBanner'
	import CommonFooter from '@/pages/common/Footer'
	import axios from 'axios'
	export default {
		name: 'Article7',
		components: {
			CommonHeader,
			RobotBanner,
			CommonFooter
		},
		data() {
			return {}
		},
		methods: {
			toback() {
				this.$router.push({
					path: '/robot/desc'
				})
			}
		},
		mounted() {
			document.getElementById('link1').scrollIntoView()
		}
	};
</script>

<style lang="scss" scoped>
	.content_item a {
		color: #000000;
		text-decoration: none;
	}
	
	div.title {
		font-size: 22px;
		font-weight: 600;
		text-align: center;
		letter-spacing: 2px;
	}
	
	p.tag {
		font-size: 20px;
		font-weight: 600;
		margin-top: 30px;
	}
	
	p.text {
		font-size: 16px;
		line-height: 30px;
		letter-spacing: 1px;
	}
	
	div.tips {
		border-bottom: 3px solid #F0F0F0;
		a {
			font-size: 24px;
			font-weight: 600;
			color: #333;
			text-decoration: none;
			cursor: pointer;
			letter-spacing: 2px;
			&:hover {
				color: #f39c12;
			}
		}
		.s1 {
			padding: 0 15px;
		}
		.s2 {
			letter-spacing: 2px;
			font-size: 18px;
		}
	}
</style>